import { windowExist } from 'src/shared/constants';
export var EVENT_ON_ERROR = 'fetchApiError';
export var BASE_URL_SERVICES = '';
export var BASE_PARAMS_SERVICES = {};
export var ERROR_CODE;
(function (ERROR_CODE) {
    ERROR_CODE[ERROR_CODE["CONFLICT"] = 409] = "CONFLICT";
    ERROR_CODE[ERROR_CODE["NOT_FOUND"] = 404] = "NOT_FOUND";
})(ERROR_CODE || (ERROR_CODE = {}));
export var API_NAME = {
    configServerApi: 'API_CONFIG',
    caseApi: 'API_CASE',
    searchApi: 'API_SEARCH',
    iamApi: 'API_IAM',
    pagePushFeed: 'API_PAGE_PUSH_SSE',
};
export var API_ENDPOINT = windowExist
    ? {
        KEYCLOAK: {
            DEFAULT: function (realm) { return "".concat(window.env.API_KEYCLOAK, "/realms/").concat(realm); },
        },
        CONFIGS: {
            DEFAULT: "".concat(window.env.API_CONFIG, "/"),
            MO_CONFIG: function (realm) { return "".concat(window.env.API_CONFIG, "/").concat(realm, "/data/configuration-mo.json"); },
            I18N_MO_SYSTEM: function (locale) { return "".concat(window.env.API_CONFIG, "/").concat(SYSTEM_REALM, "/data/i18n-mo-").concat(locale, ".json"); },
            I18N_MO_REALM: function (realm, locale) { return "".concat(window.env.API_CONFIG, "/").concat(realm, "/data/i18n-mo-").concat(locale, ".json"); },
            I18N_DEFAULT_LOCALE: function (locale) { return "".concat(window.env.BASE_PATH, "/locales/").concat(locale, ".json"); },
            I18N_KYC: function (realm) { return "".concat(window.env.API_CONFIG, "/").concat(realm, "/kyc/messages/controls"); },
            TEAMS: function (realm) { return "".concat(window.env.API_CONFIG, "/").concat(realm, "/mappers/teams"); }, // need auth
        },
        SEARCH: {
            DEFAULT: window.env.API_SEARCH,
            SEARCH: function (realm) { return "".concat(window.env.API_SEARCH, "/").concat(realm, "/cases/search"); },
            CASES_CSV_EXPORT: function (realm) { return "".concat(window.env.API_SEARCH, "/").concat(realm, "/cases/search/export"); }, // need auth
        },
        CASES: {
            DEFAULT: window.env.API_CASE,
            CASE_DETAILS: function (realm, caseToken) { return "".concat(window.env.API_CASE, "/").concat(realm, "/").concat(caseToken); },
            UPDATE_DOC_STATUS_V4: function (realm, productToken) {
                return "".concat(window.env.API_CASE, "/").concat(realm, "/").concat(productToken, "/middle-office/update-document-category-status");
            },
            UPDATE_DOC_STATUS_V5: function (realm, productToken) {
                return "".concat(window.env.API_CASE, "/").concat(realm, "/").concat(productToken, "/middle-office/update-proof-element-status");
            },
            SEND_COMMENTS_V5: function (realm, productToken) {
                return "".concat(window.env.API_CASE, "/").concat(realm, "/").concat(productToken, "/middle-office/post-internal-comment");
            },
            SEND_COMMENTS_V4: function (realm, productToken) {
                return "".concat(window.env.API_CASE, "/").concat(realm, "/").concat(productToken, "/post-internal-comment");
            }, // need auth V5
        },
        IAM: {
            DEFAULT: window.env.API_IAM,
            PERMISSION: function (realm) { return "".concat(window.env.API_IAM, "/").concat(realm, "/permissions/check"); },
            GROUPS: function (realm) { return "".concat(window.env.API_IAM, "/").concat(realm, "/groups"); }, // need auth
        },
        USERS: {
            SEARCH: function (realm, queryParam) { return "".concat(window.env.API_IAM, "/").concat(realm, "/user/list").concat(queryParam); },
            USERS_CSV_EXPORT: function (realm) { return "".concat(window.env.API_IAM, "/").concat(realm, "/user/export"); },
            USERS_CSV_IMPORT: function (realm) { return "".concat(window.env.API_IAM, "/").concat(realm, "/user/import"); },
            USER_DETAILS: function (realm, keycloakId) { return "".concat(window.env.API_IAM, "/").concat(realm, "/user/").concat(keycloakId); },
            UPDATE_USER: function (realm) { return "".concat(window.env.API_IAM, "/").concat(realm, "/user"); },
            DELETE_USER: function (realm, keycloakId) { return "".concat(window.env.API_IAM, "/").concat(realm, "/user/").concat(keycloakId); }, //need auth
        },
    }
    : null;
export var SYSTEM_REALM = 'system';
export var E_SSE_CHANNELS;
(function (E_SSE_CHANNELS) {
    E_SSE_CHANNELS["PAGE"] = "mo.case.pages";
    E_SSE_CHANNELS["UPDATES"] = "mo.case.updates";
    E_SSE_CHANNELS["ADDITIONAL_COMPONENTS"] = "mo.case.additionalComponents";
    E_SSE_CHANNELS["HISTORY"] = "mo.case.history";
    E_SSE_CHANNELS["INTERNAL_COMMENTS"] = "mo.case.internalComments";
})(E_SSE_CHANNELS || (E_SSE_CHANNELS = {}));
export var SSE_ENDPOINT = windowExist
    ? {
        DEFAULT: window.env.API_PAGE_PUSH_SSE,
        CASE_DETAILS: function (realm, caseToken) { return "".concat(window.env.API_PAGE_PUSH_SSE, "/").concat(realm, "/feeds/").concat(caseToken); },
    }
    : null;
